import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  SeguroUupo,
  SeguroUupoEnglish, // Import the other component you want to conditionally render
  Footer,
} from '../../components';
import config from '../../config';

import css from './SeguroUupoPage.module.css';

const SeguroUupoPageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const locale = intl.locale; // Extract the current locale

  const tabs = [
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.tsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ServicesFreePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.pcTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CancellationPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.rpTabTitle' }),
      selected: false,
      linkProps: {
        name: 'RefundPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.pcmTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CausesPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.usegTabTitle' }),
      selected: true,
      linkProps: {
        name: 'SeguroUupoPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.segypTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SecurityPriorityPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommunicationSafetyPage.comunicationSafetyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommunicationSafetyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.tpcdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermProtectionPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.hipdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ProtectionDataPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'SeguroUupoPage.pcookiesTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CookiesPolicyPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'SeguroUupoPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SeguroUupoPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain className={css.contentHeading}>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="SeguroUupoPage.heading" />
            </h1>
            {locale === 'en-UK' ? <SeguroUupoEnglish /> : <SeguroUupo />}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

SeguroUupoPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const SeguroUupoPage = compose(connect(mapStateToProps), injectIntl)(SeguroUupoPageComponent);

export default SeguroUupoPage;
